module.exports = (__webpack_require__(15))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/createClass.js from dll-reference vendor_library
// module id = 44
// module chunks = 0